import '@pnotify/core/dist/PNotify.css';
import '@pnotify/bootstrap4/dist/PNotifyBootstrap4.css';
import '@pnotify/mobile/dist/PNotifyMobile.css';

import { alert, defaultModules } from '@pnotify/core/dist/PNotify';
import * as PNotifyMobile from '@pnotify/mobile';
import * as PNotifyBootstrap4 from '@pnotify/bootstrap4';

defaultModules.set(PNotifyMobile, {});
defaultModules.set(PNotifyBootstrap4, {});

export const notify = (options) => {
  if (typeof window.stackBarBottom === 'undefined') {
    window.stackBarBottom = {
      dir1: 'up',
      firstpos1: 0,
      spacing1: 0,
    };
  }

  const opts = {
    title: '',
    text: '',
    shadow: true,
    mouseReset: false,
    width: '100%',
    delay: 1000,
    ...options,
  };

  alert(opts);
};

window.notify = notify;
